// @ts-check
import PropTypes from "prop-types"
import React, { Component } from "react"
import { css } from "react-emotion"
import { Label } from "ui"

const attributeclasses = css`
    margin-bottom: 10px;
    padding: 0 10px;
    width: 100%;
    & > label {
        color: #666;
        font-weight: bold;
    }

    .Dropdown-root {
        font-size: 1em;
        margin-left: 0;
        display: block;
        width: 100%;
    }
`

/**
 * @augments {Component<{label: string, field: string, attributes: {[keyof: string]: any}, setAttr: (field: string, value: any) => void, render: (value: any, onChange: (value: any) => void) => any }>}
 */
class RenderRowAttribute extends Component {
    getStateAndProps = () => ({
        ...this.props,
        value: this.props.params[this.props.field],
        onChange: value => this.props.setAttr(this.props.field, value),
    })
    render() {
        return (
            <div className={attributeclasses}>
                <Label>{this.props.label}</Label>
                {this.props.render(this.getStateAndProps())}
            </div>
        )
    }
}

RenderRowAttribute.propTypes = {
    render: PropTypes.func.isRequired,
    field: PropTypes.string.isRequired,
}

export default RenderRowAttribute



// WEBPACK FOOTER //
// ./src/features/editor/attributes/RenderRowAttribute.js